import { BaseUrl } from "../../helper/BaseUrl";

export default function CloneAppService({ section2 }) {
  return (
    <>
      {section2.url && (
        <section className="custom-enterprises lyft-enterprises">
          <img src="../assets/home/get-bg.webp" alt="logo" className="img-responsive  left-vector" loading="lazy"/>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="enterprises-head">
                  <h4 className="heading">
                    {section2 && section2.title}
                  </h4>
                  <p>
                    {section2 && section2.para}
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="enterprises-box">
                  <div className="enterprises-logo">
                    <img src={section2 && `${BaseUrl}${section2.box_icon1}`} alt="logo" className="img-responsive" />
                  </div>
                  <h4 className="heading">{section2 && section2.box_title1}</h4>
                  <p>{section2 && section2.box_para1}</p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="enterprises-box">
                  <div className="enterprises-logo">
                    <img src={section2 && `${BaseUrl}${section2.box_icon2}`} alt="logo" className="img-responsive" />
                  </div>
                  <h4 className="heading">{section2 && section2.box_title2}</h4>
                  <p>{section2 && section2.box_para2}</p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="enterprises-box">
                  <div className="enterprises-logo">
                    <img src={section2 && `${BaseUrl}${section2.box_icon3}`} alt="logo" className="img-responsive"/>
                  </div>
                  <h4 className="heading">{section2 && section2.box_title3}</h4>
                  <p>{section2 && section2.box_para3}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

    </>
  );
}
